import TagsBox from './Views/TagsBox.view';
export default TagsBox;
